<template>
  <div class="no-data">
    <image :src="NoData" v-if="type === 'default'" />
    <image :src="SearachNoData" v-if="type === 'search'" />
    <text>{{ content }}</text>
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import NoData from '@/assets/images/icon_nodata.svg'
import SearachNoData from '@/assets/images/search_nodata.svg'
export default defineComponent({
  props: {
    type: {
      type: String,
      default: 'default'
    },
    content: {
      type: String,
      default: '暂无数据'
    }
  },
  setup() {
    return { NoData, SearachNoData }
  }
})
</script>

<style lang='scss'>
.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  gap: 8px;
}
.no-data image {
  width: 60px;
  height: 60px;
  object-fit: cover;
  margin-bottom: 10px;
}
.no-data text {
  font-size: 14px;
  color: #aaa;
}
</style>
